'use strict';

class CInputMoneyController {
    constructor() {
    }

    $onInit() {
  }
}
export default CInputMoneyController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components-bootstrap/c-input-money/c-input-money.controller.js